<template>
  <div class="body-custom" v-loading="loading">
    <div class="card card-custom card-stretch gutter-b">
      <div class="card-header">
        <div class="card-title">
          <span class="card-icon">
            <i class="flaticon2-delivery-package text-primary"></i>
          </span>
          <h3 class="card-label"><b class="title-header">{{BusinessTitle}}</b></h3>
        </div>
      </div>
      <div class="card-body">
        <el-form ref="ruleForm"
              :model="form"
              class="form-base" v-on:submit.prevent="isSubmit=true">
          <div class="row mb-8">
            <div class="col-md-2">
              <label class="el-form-item__label form-item-start-template">事業名</label>
            </div>
            <el-form-item prop="jigyo_name" class="col-md-4">
              <el-input class="bg-gray-item" maxlength="32" placeholder="" v-model="form.jigyo_name"></el-input>
            </el-form-item>
          </div>

          <div class="row mb-8">
            <div class="col-md-2">
              <label class="el-form-item__label form-item-start-template">事業概要</label>
            </div>
            <el-form-item prop="jigyo_gaiyo" class="col-md-4">
              <el-input class="bg-gray-item" maxlength="300" type="textarea" placeholder="" v-model="form.jigyo_gaiyo"></el-input>
            </el-form-item>
          </div>

          <div class="row mb-4">
            <div class="col-md-2">
              <label class="el-form-item__label form-item-start-template">事業期間</label>
            </div>

            <div class="col-md-4 d-flex justify-content-between">
              <el-form-item prop="jigyo_kikan_from">
                <el-date-picker v-model="form.jigyo_kikan_from" format="yyyy/MM/dd" value-format="yyyy-MM-dd" type="date" prefix-icon="el-icon-arrow-down" style="width: 100%"
                  :editable="false"></el-date-picker>
              </el-form-item>
              <div class="col-md-2">
                <span style="font-size: 22px" class="d-flex justify-content-center"> ～ </span>
              </div>

              <el-form-item prop="jigyo_kikan_to">
                <el-date-picker v-model="form.jigyo_kikan_to" format="yyyy/MM/dd" type="date" value-format="yyyy-MM-dd" prefix-icon="el-icon-arrow-down" style="width: 100%"
                  :editable="false"></el-date-picker>
              </el-form-item>
            </div>
          </div>

          <div class="row mb-8">
            <div class="col-md-2">
              <label class="el-form-item__label form-item-start-template">交付決定額(税抜き)</label>
            </div>
            <el-form-item prop="jigyo_koufu_gaku" class="col-md-4">
              <el-input class="bg-gray-item" maxlength="20" @blur="form.jigyo_koufu_gaku = convertbyte(form.jigyo_koufu_gaku)"
                @focus="form.jigyo_koufu_gaku = convertReplace(form.jigyo_koufu_gaku)" v-model.lazy="form.jigyo_koufu_gaku">
              </el-input>
            </el-form-item>
          </div>

          <div class="row mb-8">
            <div class="col-md-2">
              <label class="el-form-item__label form-item-start-template">税率</label>
            </div>
            <el-form-item prop="tax_rate" class="col-md-4">
              <el-input class="bg-gray-item" maxlength="11" v-model.lazy="form.tax_rate"
                onfocus="if(this.value) this.value = this.value.replace(/\D/g, '')"
                onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                @blur="form.tax_rate = form.tax_rate.replace(/\D/g, ''); form.tax_rate = Number(form.tax_rate) > 100 ? '100' : form.tax_rate"
              >
                <template slot="suffix">%</template>
              </el-input>
            </el-form-item>
          </div>

            <div v-if="currentUser && currentUser.super_user == 1">
                <div class="row mb-8">
                    <div class="col-md-2">
                        <label class="el-form-item__label form-item-start-template">TEL番号</label>
                    </div>
                    <el-form-item prop="phone" class="col-md-4">
                        <el-input class="bg-gray-item" maxlength="300" placeholder="" v-model="form.phone"></el-input>
                    </el-form-item>
                </div>
            </div>
          <div class="row mb-8">
            <div class="col-md-5">
              <el-button class="" type="primary" @click="submit()">登録</el-button>
            </div>
          </div>
          <input type="hidden" name="_csrf" v-model="form._csrf" />
        </el-form>
      </div>
    </div>
  </div>

</template>

<script>
import { ADD_BUSINESS, SET_TITLE_BUSINESS } from "@/core/services/store/business.module";
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment'
import routeTenant from "@/core/services/routeTenant.service"
import { SUCCESS_MESSAGE } from "@/core/config/constant";
import { getCsrfRandom } from "@/core/services/store/auth.module";

export default {
  name: "create",
  data() {
    return {
      form: {
        jigyo_name: '',
        jigyo_gaiyo: '',
        jigyo_kikan_from: null,
        jigyo_kikan_to: null,
        jigyo_koufu_gaku: '',
        tax_rate: null,
        // use_tax: 0,
          phone:'',
          _csrf:''
      },
      loading: false,
      isSubmit: false,
      flags: [
        {
          'label': '表示',
          'value': 0,
        },
        {
          'label': '非表示',
          'value': 1,
        }
      ],
      length_jigyo_koufu_gaku: 20,
      tax_options: [
        {
          value: 1,
          label: '税込み入力'
        },
        {
          value: 0,
          label: '税抜き入力'
        }
      ]
    };
  },
  watch: {
  },
  async created() {
    this.loading = true;
    await this.setTitleBusiness()
    const business = this.getBusiness
    if (business) {
      this.form = business
      this.form.jigyo_koufu_gaku = BigInt(String(business.jigyo_koufu_gaku).replace(/\D/g, ''), 10).toLocaleString('ja-JP', { currency: 'JPY' })
    }
    this.form._csrf = getCsrfRandom()
    this.loading = false;
  },
  computed: {
    ...mapGetters(["BusinessStatus", "BusinessErrors", "BusinessTitle", "getBusiness",'currentUser']),
  },
  methods: {
    ...mapActions([ADD_BUSINESS, SET_TITLE_BUSINESS]),
    async submit() {
      this.isSubmit = true
      this.$refs["ruleForm"].clearValidate()
      this.loading = true

      const dataInsert = {
        jigyo_name: this.form.jigyo_name,
        jigyo_gaiyo: this.form.jigyo_gaiyo,
        jigyo_kikan_from: this.form.jigyo_kikan_from,
        jigyo_kikan_to: this.form.jigyo_kikan_to,
        jigyo_koufu_gaku:  this.form.jigyo_koufu_gaku ? this.form.jigyo_koufu_gaku.replaceAll(',', '') : this.form.jigyo_koufu_gaku ,
        tax_rate: Number(this.form.tax_rate),
        // use_tax: this.form.use_tax,
          phone:this.form.phone,
      }

      await this.addBusiness(dataInsert)
      if (this.BusinessStatus == 200) {
        this.notifySuccess(SUCCESS_MESSAGE)
        await this.$store.dispatch(SET_TITLE_BUSINESS)
        this.reset()
      }
      if (this.BusinessStatus == 422) {
        this.showErrorMessage(this.BusinessErrors, "ruleForm")
      }
      if (this.BusinessStatus == 400) {
        this.notifyError("duplicate business")
      }
      this.loading = false
      this.isSubmit = false
    },
    reset() {
      this.$refs["ruleForm"].resetFields()

      const business = this.getBusiness
      if (business) {
        this.form = business
        this.form.jigyo_koufu_gaku = BigInt(String(business.jigyo_koufu_gaku).replace(/\D/g, ''), 10).toLocaleString('ja-JP', { currency: 'JPY' })
      }
    },
    convertbyte(money){
      if(money){
      for (let i = 0; i < money.length; i++)
        {
          if (money[i] < '0' || money[i] > '9' && money[i] < '０' || money[i] > '９'){
            money = money.substring(0, i) + money.substring(i + 1);
            i--;
          }
        }
       money = this.fullWidthNumConvert(money);
      if(money){
        return BigInt(money.replace(/\D/g, ''), 10).toLocaleString('ja-JP', { currency: 'JPY' });
      }
    }

    },
   fullWidthNumConvert(fullWidthNum){
    var ascii = '';
    if(fullWidthNum){
        for(var i=0, l=fullWidthNum.length; i<l; i++) {
            var c = fullWidthNum[i].charCodeAt(0);
            if (c >= 0xFF00 && c <= 0xFFEF) {
               c = 0xFF & (c + 0x20);
            }

        ascii += String.fromCharCode(c);
        }
    }

    return ascii;

    },
    convertReplace(value) {
      if (value) {
        return value.replace(/\D/g, '')
      }
    },

  }
}
</script>

<style scoped>

</style>
